import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Spacing from '../layout/Spacing';
import ColorProvider from '../chrome/ColorProvider';
import Grid from '../layout/Grid';
import Heading from '../chrome/Heading';
import Text from '../chrome/Text';
import Image from '../chrome/Image';

const imageContainerBaseStyles = () => css`
  max-width: 100px;
`;

const ImageContainer = styled('div')(imageContainerBaseStyles);

const prizeDotGroupBaseStyles = ({ theme }) => css`
  display: flex;
  margin-bottom: ${theme.spacings.kilo};
`;

const PrizeDotGroup = styled('div')(prizeDotGroupBaseStyles);

const prizeDotBaseStyles = ({ theme }) => css`
  margin-right: ${theme.spacings.giga};
  max-width: 30px;
`;

const PrizeDot = styled('div')(prizeDotBaseStyles);

const TextGroup = styled('div')();

const RewardItem = ({ assetUrl, assetAlt, level, instructionText, rewardText }) => (
  <Grid>
    {assetUrl && (
      <ImageContainer>
        <Image src={assetUrl} alt={assetAlt} />
      </ImageContainer>
    )}
    <Spacing sizeLeft='kilo'>
      <PrizeDotGroup>
        {[0, 1, 2].map((num, index) => (
          <PrizeDot key={index}>
            <Image src={`https://hockeygame.s3.amazonaws.com/${num <= level ? 'PuckRed.png' : 'PuckGrey.png'}`} />
          </PrizeDot>
        ))}
      </PrizeDotGroup>
      <TextGroup>
        <Text size='tera' bold noMargin>
          {instructionText}
        </Text>
        <ColorProvider variant='red'>
          <Heading size='kilo' bold noMarginBoth>
            {rewardText}
          </Heading>
        </ColorProvider>
      </TextGroup>
    </Spacing>
  </Grid>
);

RewardItem.propTypes = {
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
  level: PropTypes.number,
  instructionText: PropTypes.string,
  rewardText: PropTypes.string,
};

export default RewardItem;
